import { modelComposition } from 'trait/composition'

const descriptor = 'model::ticket::solution'

export default modelComposition(descriptor)
